function findTutorials(tutorialData, manufacturer) {
    return tutorialData.tutorials[manufacturer];
}
export { findTutorials };
